


// import React, { useContext } from "react";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";
// import Rightcontainer from "../Components/Rightcontainer";

// const Mywallet = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   const translations = {
//     hi: {
//       status: "खाता स्थिति",
//       verified: "सत्यापन पूरा हुआ",
//       deposit: "डिपॉजिट चिप्स",
//       winnings: "विनिंग चिप्स",
//       availablePlay: "खेलने के लिए उपलब्ध",
//       withdrawBal: "निकालने योग्य शेष",
//       add: "Add Chips",
//       withdraw: "Withdraw",
//       secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
//     },
//     en: {
//       status: "Account Status",
//       verified: "Verification Completed",
//       deposit: "Deposit Chips",
//       winnings: "Winning Chips",
//       availablePlay: "Available for play",
//       withdrawBal: "Withdrawable balance",
//       add: "Add Chips",
//       withdraw: "Withdraw",
//       secure: "Your transactions are 100% secure and encrypted.",
//     },
//   };

//   const t = translations[language] || translations.en;

//   const depositAmount = user ? (user.Wallet_balance - user.withdrawAmount).toFixed(2) : "0.00";
//   const winningAmount = user ? user.withdrawAmount.toFixed(2) : "0.00";

//   return (
//     <div className="wallet-page-wrapper leftContainer mt-5 pt-5">
//       <div className="wallet-main-content">
        
//         {/* Verification Status Header */}
//         <div className="status-banner">
//           <div className="avatar-wrapper">
//              <img src="/avatarwallet.png" alt="user" className="status-avatar" />
//              <div className="plus-badge">+</div>
//           </div>
//           <div className="status-info">
//             <span className="status-label">{t.status}</span>
//             <h2 className="status-text">{t.verified}</h2>
//           </div>
//         </div>

//         {/* Deposit Card */}
//         <div className="balance-card deposit-card">
//           <div className="card-top-row">
//             <span className="card-title">{t.deposit}</span>
//             <div className="chip-icon">₹</div>
//           </div>
//           <div className="amount-display">₹{depositAmount}</div>
//           <div className="amount-subtext">{t.availablePlay}</div>
//           <Link to="/addcase" className="action-btn add-btn">
//             {t.add}
//           </Link>
//         </div>

//         {/* Winnings Card */}
//         <div className="balance-card winning-card">
//           <div className="card-top-row">
//             <span className="card-title">{t.winnings}</span>
//             <div className="chip-icon purple">₹</div>
//           </div>
//           <div className="amount-display">₹{winningAmount}</div>
//           <div className="amount-subtext">{t.withdrawBal}</div>
//           <Link to="/Withdrawopt" className="action-btn withdraw-btn">
//             {t.withdraw}
//           </Link>
//         </div>

//         <p className="secure-text-footer">{t.secure}</p>
//       </div>

//       <div className="rightContainer mobile-hide">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Mywallet;



import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "../Components/LanguageContext";
import Rightcontainer from "../Components/Rightcontainer";

const Mywallet = ({ user }) => {
  const { language } = useContext(LanguageContext);

  const translations = {
    hi: {
      status: "खाता स्थिति",
      verified: "सत्यापन पूरा हुआ",
      deposit: "डिपॉजिट चिप्स",
      winnings: "विनिंग चिप्स",
      availablePlay: "खेलने के लिए उपलब्ध",
      withdrawBal: "निकालने योग्य शेष",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "आपके ट्रांजैक्शन 100% सुरक्षित और एन्क्रिप्टेड हैं।",
    },
    en: {
      status: "Account Status",
      verified: "Verification Completed",
      deposit: "Deposit Chips",
      winnings: "Winning Chips",
      availablePlay: "Available for play",
      withdrawBal: "Withdrawable balance",
      add: "Add Chips",
      withdraw: "Withdraw",
      secure: "Your transactions are 100% secure and encrypted.",
    },
  };

  const t = translations[language] || translations.en;

  const depositAmount = user ? (user.Wallet_balance - user.withdrawAmount).toFixed(2) : "0.00";
  const winningAmount = user ? user.withdrawAmount.toFixed(2) : "0.00";

  return (
    <div className="wallet-page-wrapper leftContainer mt-5 pt-5 premium-wallet-root">
      <div className="wallet-main-content">
        
        {/* Verification Status Header */}
        <div className="status-banner premium-status-banner">
          <div className="avatar-wrapper premium-avatar-wrap">
             <img src="/avatarwallet.png" alt="user" className="status-avatar" />
             <div className="plus-badge">+</div>
          </div>
          <div className="status-info">
            <span className="status-label">{t.status}</span>
            <h2 className="status-text">{t.verified}</h2>
          </div>
        </div>

        {/* Deposit Card */}
        <div className="balance-card deposit-card premium-card">
          <div className="card-top-row">
            <span className="card-title">{t.deposit}</span>
            <div className="chip-icon gold-glow">₹</div>
          </div>
          <div className="amount-display">₹{depositAmount}</div>
          <div className="amount-subtext">{t.availablePlay}</div>
          <Link to="/addcase" className="action-btn add-btn premium-btn-primary">
            {t.add}
          </Link>
        </div>

        {/* Winnings Card */}
        <div className="balance-card winning-card premium-card">
          <div className="card-top-row">
            <span className="card-title">{t.winnings}</span>
            <div className="chip-icon orange-glow">₹</div>
          </div>
          <div className="amount-display">₹{winningAmount}</div>
          <div className="amount-subtext">{t.withdrawBal}</div>
          <Link to="/Withdrawopt" className="action-btn withdraw-btn premium-btn-secondary">
            {t.withdraw}
          </Link>
        </div>

        <p className="secure-text-footer">{t.secure}</p>
      </div>

      <div className="rightContainer mobile-hide">
        <Rightcontainer />
      </div>

      {/* Inline styles for the classic premium black and orange/gold theme */}
      <style>{`
        .premium-wallet-root {
          // background-color: #0b0c10;
          color: #c5c6c7;
          min-height: 100vh;
          padding: 2rem 1rem;
        }

        .wallet-main-content {
          max-width: 520px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .premium-status-banner {
          background: linear-gradient(135deg, #1f2833 0%, #0b0c10 100%);
          border: 1px solid rgba(255, 152, 0, 0.2);
          border-radius: 16px;
          padding: 1.25rem 1.5rem;
          display: flex;
          align-items: center;
          gap: 1.25rem;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
        }

        .premium-avatar-wrap {
          position: relative;
          border-radius: 50%;
          padding: 2px;
          background: linear-gradient(135deg, #ff9800, #ff5722);
        }

        .status-avatar {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          object-fit: cover;
          display: block;
        }

        .plus-badge {
          position: absolute;
          bottom: 0;
          right: 0;
          background: #ff9800;
          color: #0b0c10;
          font-weight: bold;
          font-size: 12px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid #0b0c10;
        }

        .status-label {
          font-size: 0.85rem;
          color: #8c929d;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .status-text {
          font-size: 1.2rem;
          font-weight: 700;
          color: #ffffff;
          margin: 0;
        }

        .premium-card {
          background: linear-gradient(145deg, #151821 0%, #0f1117 100%);
          border: 1px solid rgba(255, 152, 0, 0.15);
          border-radius: 20px;
          padding: 1.75rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
          position: relative;
          overflow: hidden;
          transition: transform 0.2s ease, border-color 0.2s ease;
        }

        .premium-card:hover {
          border-color: rgba(255, 152, 0, 0.4);
          transform: translateY(-2px);
        }

        .card-top-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0.75rem;
        }

        .card-title {
          font-size: 0.95rem;
          font-weight: 600;
          color: #a0a5b0;
          letter-spacing: 0.5px;
        }

        .chip-icon {
          width: 36px;
          height: 36px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          font-size: 1.1rem;
        }

        .gold-glow {
          background: rgba(255, 152, 0, 0.15);
          color: #ff9800;
          border: 1px solid rgba(255, 152, 0, 0.3);
          box-shadow: 0 0 12px rgba(255, 152, 0, 0.2);
        }

        .orange-glow {
          background: rgba(255, 87, 34, 0.15);
          color: #ff5722;
          border: 1px solid rgba(255, 87, 34, 0.3);
          box-shadow: 0 0 12px rgba(255, 87, 34, 0.2);
        }

        .amount-display {
          font-size: 2.25rem;
          font-weight: 800;
          color: #ffffff;
          margin-bottom: 0.25rem;
          letter-spacing: -0.5px;
        }

        .amount-subtext {
          font-size: 0.85rem;
          color: #707582;
          margin-bottom: 1.25rem;
        }

        .action-btn {
          display: block;
          width: 100%;
          text-align: center;
          padding: 0.85rem;
          border-radius: 12px;
          font-weight: 700;
          font-size: 1rem;
          text-decoration: none;
          transition: all 0.2s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
        }

        .premium-btn-primary {
          background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
          color: #0b0c10;
        }

        .premium-btn-primary:hover {
          background: linear-gradient(135deg, #ffa726 0%, #fb8c00 100%);
          color: #0b0c10;
          box-shadow: 0 6px 20px rgba(255, 152, 0, 0.4);
        }

        .premium-btn-secondary {
          background: linear-gradient(135deg, #212530 0%, #1a1d26 100%);
          color: #ff9800;
          border: 1px solid rgba(255, 152, 0, 0.4);
        }

        .premium-btn-secondary:hover {
          background: linear-gradient(135deg, #ff9800 0%, #f57c00 100%);
          color: #0b0c10;
          border-color: transparent;
          box-shadow: 0 6px 20px rgba(255, 152, 0, 0.4);
        }

        .secure-text-footer {
          text-align: center;
          font-size: 0.8rem;
          color: #6c727f;
          margin-top: 0.5rem;
        }
      `}</style>
    </div>
  );
};

export default Mywallet;